'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.capitalize = capitalize;
exports.charRange = charRange;
exports.outerWidth = outerWidth;
exports.filterCollectionFromParams = filterCollectionFromParams;
exports.updateSelections = updateSelections;
exports.splitIdsList = splitIdsList;
exports.findInCollectionOrAdd = findInCollectionOrAdd;
exports.mergeCollections = mergeCollections;
exports.orderByField = orderByField;
exports.parseRange = parseRange;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function charRange(start, stop) {
  var result = [];
  for (var idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
    result.push(String.fromCharCode(idx));
  }
  return result;
}

function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);

  width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
  return width;
}

function filterCollectionFromParams(source, params) {
  if (!params) {
    return [];
  }

  return source.filter(function (item) {
    return params.indexOf(item.id) > -1;
  });
}

function updateSelections(item, selected, select) {
  var query = {
    page: 1
  };

  (0, _keys2.default)(selected).forEach(function (key) {
    var ids = selected[key].map(function (sel) {
      return sel.id;
    });

    if (ids.length > 0) {
      query[key] = ids.join(',');
    }
  });

  if (!item || !Array.isArray(selected[item.group]) || typeof select[item.group] !== 'function') {
    return query;
  }

  var index = selected[item.group].indexOf(item);
  var ids = selected[item.group].map(function (se) {
    return se.id;
  });
  switch (index > -1) {
    case true:
      // Present
      ids.splice(index, 1);

      if (ids.length === 0) {
        delete query[item.group];
      } else {
        query[item.group] = ids.join(',');
      }

      select[item.group](ids);
      break;
    case false: // Absent
    default:
      ids.push(item.id);
      query[item.group] = ids.join(',');
      select[item.group](ids);
  }

  return query;
}

function splitIdsList(list) {
  if (!list) {
    return [];
  }

  return list.split(',').map(function (str) {
    return parseInt(str.trim(), 10);
  });
}

function findInCollectionOrAdd(item, collection) {
  if (!collection.find(function (seenItem) {
    return seenItem.id === item.id;
  })) {
    collection.push(item);
  }
  return collection;
}

function mergeCollections(items, collection) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      findInCollectionOrAdd(item, collection);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return collection;
}

function orderByField(collection, field) {
  if (!Array.isArray(collection)) {
    return collection;
  }

  return collection.sort(function (itemA, itemB) {
    return String(itemA[field]).localeCompare(String(itemB[field]), 'fr');
  });
}

function parseRange(rangeParam) {
  if (!rangeParam || rangeParam.indexOf(',') === -1) {
    return { start: null, end: null };
  }

  var rangeParts = rangeParam.split(',');
  return {
    start: rangeParts[0],
    end: rangeParts[1]
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/utils.js
// module id = 144
// module chunks = 0